module.exports = __webpack_public_path__ + "static/media/vip.dd62c84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/悬浮窗/vip.png
// module id = 977
// module chunks = 0